// extracted by mini-css-extract-plugin
export default {"container":"notification_container__oFD9o","ok":"notification_ok__B3vnk","warning":"notification_warning__eOXuh","error":"notification_error__0oPzm"};